import React from "react";
import { QuoteIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { testimonials } from "../data/content";
export function Testimonials() {
  return <section className="bg-canvas px-4 py-16 sm:px-6 sm:py-20" data-id="element-272" data-mp="3fyco1fyxbt7m">
      <div className="mx-auto max-w-5xl" data-id="element-273" data-mp="3b148ln55u3a2">
        <SectionHeading kicker="What other technicians are saying" title="A Better Diagnostic Process Starts with a Better System" data-id="element-274" data-mp="3b01e758mpipe" />

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-275" data-mp="31zmto83ho7my">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-sm" data-id="element-276" data-mp="2x004d0adz0xs">
              <QuoteIcon className="h-8 w-8 text-brand" aria-hidden="true" data-id="element-277" data-mp="2s28bo41x3asj" />
              <blockquote className="mt-3 flex-1 text-[16px] leading-relaxed text-ink" data-id="element-278" data-mp="v9g9pm6l60om">“{t.quote}”</blockquote>
              <figcaption className="mt-6 flex items-center gap-4 border-t border-ink/10 pt-5" data-id="element-279" data-mp="qalko2i0zfw2">
                <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-brand-light" data-id="element-280" data-mp="h67wpwq6ta6o" />
                <div data-id="element-281" data-mp="780kfr6ufgb0">
                  <p className="font-display text-lg font-bold text-ink" data-id="element-282" data-mp="78tv338xapyf">{t.name}</p>
                  <p className="text-sm leading-snug text-ink-muted" data-id="element-283" data-mp="c6bua1x51qt8">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <div className="mt-10" data-id="element-284" data-mp="14vj2xtqb3ws7">
          <CtaButton label="I want to work like this too" arrow data-id="element-285" data-mp="14vsjkqpgorl8" />
        </div>
      </div>
    </section>;
}